import { format, formatDistance, formatDistanceToNow } from "date-fns";
export const formatDate = (date, formatStyle, locale) => {
    return format(date instanceof Date ? date : new Date(date), formatStyle, {
        locale,
    });
};
export const formatRelativeTimeDistanceFromSeconds = (fromSeconds, locale) => {
    return formatDistance(0, fromSeconds * 1000, {
        includeSeconds: false,
        locale,
    });
};
export const formatDateDistance = (dateFrom, dateTo, locale) => {
    return formatDistance(dateFrom instanceof Date ? dateFrom : new Date(dateFrom), dateTo instanceof Date ? dateTo : new Date(dateTo), { locale, addSuffix: true });
};
export const formatDateDistanceToNow = (date, locale) => {
    return formatDistanceToNow(date instanceof Date ? date : new Date(date), {
        locale,
        addSuffix: true,
    });
};
